import { LIVE_MATHS_CLASS_RETRIEVED } from './single-class-actions';

const initialState = null;

/**
 * Live Maths - Single Class Reducer
 *
 * Consumes LIVE_MATHS_CLASS_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case LIVE_MATHS_CLASS_RETRIEVED:
            return action.payload;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/live-maths/single-class/single-class-reducer.js